import { FormGroup, InputHidden, InputMask, Label } from '~/components/unform'
import { useAPPTranslation } from '~/i18n/useAPPTranslation'

export const IdentificationNumberPE = () => {
  const { t } = useAPPTranslation()

  return (
    <FormGroup className="span2">
      <Label>RUC</Label>

      <InputHidden defaultValue="RUC" name="identificationType" />

      <InputMask
        name="identificationNumber"
        placeholder={t('rm:payment.billing.identificationNumber.placeholder')}
        required
        mask="###########"
      />
    </FormGroup>
  )
}
